import React, {useState} from 'react';
import {DownloadCloud, FileText, X} from "react-feather";
import {Button, CardText, Col, FormFeedback, Input, Label, ListGroup, ListGroupItem, Row, Spinner} from "reactstrap";
import {useDropzone} from "react-dropzone";
import toast from 'react-hot-toast'
import axios from "axios";
import {Controller, useForm} from "react-hook-form";

const UploadTemplate = ({onClose}) => {

    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const defaultValues = {
        name: ''
    };
    const {
        control,
        setError,
        handleSubmit,
        formState: { errors }
    } = useForm({defaultValues});

    const { getRootProps, getInputProps } = useDropzone({
        multiple: false,
        accept: {
            'application/msword': ['.doc', '.docx']
        },
        onDrop: (acceptedFiles, rejectedFiles) => {
            if (rejectedFiles.length) {
                toast.error('Solo se pueden cargar archivos en formato word!.')
            } else {
                setFiles([...files, ...acceptedFiles.map(file => Object.assign(file))])
            }
        }
    })

    const renderFilePreview = file => {
        if (file.type.startsWith('image')) {
            return <img className='rounded' alt={file.name} src={URL.createObjectURL(file)} height='28' width='28' />
        } else {
            return <FileText size='28' />
        }
    }

    const handleRemoveFile = file => {
        const filtered = files.filter(i => i.name !== file.name)
        setFiles([...filtered])
    }

    const renderFileSize = size => {
        if (Math.round(size / 100) / 10 > 1000) {
            return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`
        } else {
            return `${(Math.round(size / 100) / 10).toFixed(1)} kb`
        }
    }

    const fileList = files.map((file, index) => (
        <ListGroupItem key={`${file.name}-${index}`} className='d-flex align-items-center justify-content-between'>
            <div className='file-details d-flex align-items-center'>
                <div className='file-preview me-1'>{renderFilePreview(file)}</div>
                <div>
                    <p className='file-name mb-0'>{file.name}</p>
                    <p className='file-size mb-0'>{renderFileSize(file.size)}</p>
                </div>
            </div>
            <Button color='danger' outline size='sm' className='btn-icon' onClick={() => handleRemoveFile(file)}>
                <X size={14} />
            </Button>
        </ListGroupItem>
    ))

    const handleRemoveAllFiles = () => {
        setFiles([])
    }

    const uploadTemplate = async () => {
        const requestsUploadTemplates = [];
        for (const file of files) {
            const formData = new FormData();
            formData.append("template", file)
            requestsUploadTemplates.push(axios.post(`${process.env.REACT_APP_API_NODE_URL}/upload/template/crediq`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }))
        }
        toast.success('Plantilla cargada con exito!')
        return await Promise.all(requestsUploadTemplates);
    }

    const onSubmit = async (data) => {
        if (Object.values(data).every(field => field.length > 0)) {

            try {
                setLoading(true);
                const resultUpload = await uploadTemplate();
                await axios.post(`${process.env.REACT_APP_API_URL}/templates`,{
                    name: data.name,
                    urlDocument: resultUpload[0].data.file.location
                });
                setLoading(false);
                toast.success('Plantilla creada con exito!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (e) {
                setLoading(false);
                toast.error(`Ha ocurrido un error: ${e.message}`);
            }

        } else {
            for (const key in data) {
                if (data[key].length === 0) {
                    setError(key, {
                        type: 'manual'
                    })
                }
            }
        }
    }

    return (
        loading ? <Row>
            <div className='col-12 px-2 py-4 text-center'>
                <Spinner size='lg'/>
                <CardText className={'py-1 fs-5'}>Subiendo plantillas...</CardText>
            </div>
        </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
            <Col md={12} xs={12}>
                <Label className='form-label' for='name'>
                    Nombre plantilla*
                </Label>
                <Controller
                    control={control}
                    name='name'
                    render={({ field }) => {
                        return (
                            <Input
                                {...field}
                                id='name'
                                placeholder='Contrato de personal'
                                value={field.value}
                                invalid={errors.name && true}
                            />
                        )
                    }}
                />
                {errors.name && <FormFeedback>Por favor ingrese un nombre de plantilla valido</FormFeedback>}
            </Col>


            {files.length === 0 && <Col md={12} xs={12} className={'pt-1 px-3'}><Row {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <div className='d-flex align-items-center justify-content-center flex-column'>
                    <DownloadCloud size={64} />
                    <h5>Arrastra un archivo aqui (.doc, .docx) para cargar</h5>
                    <p className='text-secondary'>
                        o click en {' '}
                        <a href='/' onClick={e => e.preventDefault()}>
                            seleccionar un archivo
                        </a>{' '}
                        desde tu dispositivo
                    </p>
                </div>
            </Row></Col>}

            {files.length > 0 && (
                <Col md={12} xs={12}>
                    <ListGroup className='my-2'>{fileList}</ListGroup>
                </Col>
            )}

            <Col md={12} xs={12}>
                <small className={'text-secondary'}>
                    Campos obligatorios (*)
                </small>
            </Col>

            <Col md={12} xs={12}>
                <hr/>
            </Col>

            <Col md={12} xs={12}>
                <div className='d-flex justify-content-end'>
                    <Button className='me-1' disabled={files.length === 0} color='danger' outline onClick={handleRemoveAllFiles}>
                        Remover
                    </Button>
                    <Button type='submit' disabled={files.length === 0} color='primary'>Crear Plantilla</Button>
                </div>
            </Col>


        </Row>
    );
};

export default UploadTemplate;
